const Banner = ({ bannerSection }) => {
  return (
    <div className="section__banner">
      <div className="section__banner__container desktop" data-bg={bannerSection?.desktopImage?.sourceUrl}>
        <h1>{bannerSection?.title}</h1>
        <p className="subtitle_1">{bannerSection?.paragraph}</p>
        <div className="section__banner__cta">
          <a className="button" href={bannerSection?.buttonLink}>{bannerSection?.buttonText}</a>
        </div>
      </div>
      <div className="section__banner__container mobile" data-bg={bannerSection?.mobileImage?.sourceUrl}>
        <h1>
          {bannerSection?.title}
        </h1>
        <p className="subtitle_1">{bannerSection?.paragraph}</p>
        <div className="section__banner__cta">
          <a className="button" href={bannerSection?.buttonLink}>
            {bannerSection?.buttonText}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Banner;
